import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Flag } from "lucide-react";
import { toast } from "sonner";

const REASONS = ["Conteúdo falso ou enganoso", "Ofensivo ou discriminatório", "Envolve menores de idade", "Spam ou golpe", "Foto imprópria"];

export default function ReportDialog() {
  const [target, setTarget] = useState(null);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const on = (e) => { setTarget(e.detail); setReason(""); };
    window.addEventListener("enkosta:report", on);
    return () => window.removeEventListener("enkosta:report", on);
  }, []);

  const send = async () => {
    if (reason.trim().length < 3) { toast.error("Conte rapidinho o motivo (mínimo 3 letras)."); return; }
    setBusy(true);
    try {
      await api.post("/reports", { target_type: target.type, target_id: target.id, reason: reason.trim() });
      toast.success("Denúncia enviada. Obrigado!");
      setTarget(null);
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={!!target} onOpenChange={(o) => { if (!o) setTarget(null); }}>
      <DialogContent className="z-[2200] bg-card border-white/10 rounded-2xl max-w-sm" data-testid="report-dialog">
        <DialogHeader className="text-left">
          <DialogTitle className="flex items-center gap-2 heading"><Flag className="w-4 h-4 text-destructive" /> Denunciar {target?.what}</DialogTitle>
          <DialogDescription>A equipe do Enkosta vai revisar. Sua identidade não é mostrada para quem foi denunciado.</DialogDescription>
        </DialogHeader>
        <div className="flex flex-wrap gap-2">
          {REASONS.map((r) => (
            <button key={r} type="button" onClick={() => setReason(r)} data-testid={`report-reason-${REASONS.indexOf(r)}`}
              className={`press h-8 px-3 rounded-full text-xs border ${reason === r ? "bg-primary text-primary-foreground border-primary" : "border-white/10 bg-black/30"}`}>{r}</button>
          ))}
        </div>
        <Textarea value={reason} onChange={(e) => setReason(e.target.value)} maxLength={500} rows={3} placeholder="Descreva o problema" data-testid="report-reason-input" />
        <div className="grid grid-cols-2 gap-2">
          <Button variant="outline" className="h-12 press" onClick={() => setTarget(null)} data-testid="report-cancel-button">Cancelar</Button>
          <Button variant="destructive" className="h-12 press" disabled={busy} onClick={send} data-testid="report-submit-button">{busy ? "Enviando..." : "Enviar denúncia"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
